var $ = global.jQuery = global.$;
var parser = require('../lib/parser');
var widgets = require('../lib/widgets');

var _Base = require('./_Base');

/**
 * Loading in ajax content based on href to the load target
 * @class
 * @extends _Base
 */
var AjaxLoader = _Base.extend(
  /** @lends AjaxLoader.prototype */
  {
    /**
     * Initialises the widget
     * @private
     */
    init: function() {
      var self = this;

      this.$target = $(this.widgetOptions.loadTarget);
      this.url = this.$el.attr('href');
      this.idTarget = this.url.split('#')[1];

      this.$el.on('click', function(event) {
        event.preventDefault();
        self.getAjaxContent();
        self.scrollTop = $(window).scrollTop();
      });
    },
    /**
     * Get the content from the url contained in the `href`. Can include an id fragment so you can load just the content of a part of a page.
     */
    getAjaxContent: function() {
      var self = this;

      var req = $.ajax({
          type: 'GET',
          url: self.url
        })
        .done(this._contentRequestSuccessHandler.bind(this))
        .fail(this._contentRequestErrorHandler.bind(this));
    },
    /**
     * Handle errors from the AJAX request
     * @private
     */
    _contentRequestErrorHandler: function() {
      //TODO handle error
    },
    /**
     * Handle successful AJAX request
     * @private
     */
    _contentRequestSuccessHandler: function(response) {
      var self = this;
      var targetHtml = this.idTarget ? $(response).find('#' + this.idTarget).html() : response;

      this.$target
        .removeClass('article-positioned')
        .html(targetHtml)
        .velocity('scroll');

      this.$target.children(':first').velocity('fadeIn');

      parser.parse(this.$target, function() {
        var article = widgets.getDescendants(self.$target, 'Article')[0];

        article.returnScrollPosition = self.scrollTop;
      });
    }
  });

module.exports = AjaxLoader;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/AjaxLoader.js
 ** module id = 40
 ** module chunks = 0 1
 **/